import { PomodoroService } from "features/widget-workspace/service/PomodoroService";
import { useEffect, useRef, useState } from "react";
import { TimerAlarmSoundsMap } from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { DEFAULT_ALARM_LIST } from "@lifeat/shared/widget/PomodoroTimerConstants";
import { useUserContext } from "@contexts/UserContext";

export function useAlarmSoundOptions(pomodoroService: PomodoroService) {
    const { user, userData } = useUserContext();
    const [alarmSoundOptions, setAlarmSoundOptions] = useState<TimerAlarmSoundsMap>(DEFAULT_ALARM_LIST);
    // This hook runs when the user's data is realized by Firebase and we can read their data from the DB.
    const hasInitUserData = useRef(null);

    useEffect(() => {
        if (user && userData && !hasInitUserData.current) {
            if (userData?.proUserInfo?.isProUser) {
                // If user is pro, read the pro sounds from DB (protected by security rules) and update our list of sounds.
                const updateAlarmSoundOptions = (sounds: TimerAlarmSoundsMap) => {
                    const alarmSoundsTemp: TimerAlarmSoundsMap = alarmSoundOptions;
                    if (sounds) {
                        for (const soundId of Object.keys(sounds)) {
                            alarmSoundsTemp[soundId] = sounds[soundId];
                        }
                    }
                    setAlarmSoundOptions({ ...alarmSoundsTemp });
                    hasInitUserData.current = true;
                };
                // Read the data from DB
                pomodoroService.fetchProAlarmSounds?.().then(updateAlarmSoundOptions);
            }
        }
    }, [user, userData]);

    return alarmSoundOptions;
}
